var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30066_19260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C15.9952 12.4163 12.4163 15.9952 8 16ZM8 12C7.55817 12 7.2 12.3582 7.2 12.8C7.2 13.2418 7.55817 13.6 8 13.6C8.44183 13.6 8.8 13.2418 8.8 12.8C8.8 12.3582 8.44183 12 8 12ZM8 4C8.88366 4 9.6 4.71634 9.6 5.6C9.60281 6.02458 9.43236 6.43195 9.128 6.728L8.136 7.736C7.53715 8.33737 7.20065 8.82633 7.2 9.67501C7.2 10.0754 7.52459 10.4 7.92499 10.4H7.97112C8.4189 10.4 8.76295 10.0127 8.8654 9.57684C8.99544 9.0236 9.29636 8.51739 9.736 8.136L10.456 7.4C10.9345 6.92345 11.2024 6.27529 11.2 5.6C11.2 3.83269 9.76731 2.4 8 2.4C6.50601 2.4 5.25115 3.42381 4.89874 4.80809C4.78974 5.23627 5.15817 5.6 5.6 5.6C6.04183 5.6 6.38342 5.22038 6.59558 4.83282C6.86725 4.33654 7.39432 4 8 4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30066_19260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircleIcon);
export default __webpack_public_path__ + "static/media/help-circle-icon.3127ff7825f9b563029116f4cbffeb24.svg";
export { ForwardRef as ReactComponent };